/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
function isAggregateError(error) {
    return !!error.innerError;
}
/**
 * Creates an instance of Error that aggregates and preserves an innerError.
 * @param message The error message.
 * @param innerError The inner error message to aggregate.
 * @param skipIfAlreadyAggregate Indicates to not wrap the inner error if it itself already has an innerError.
 * @return The Error instance.
 */
export function AggregateError(message, innerError, skipIfAlreadyAggregate) {
    // tslint:disable:no-parameter-reassignment
    if (innerError) {
        if (isAggregateError(innerError) && skipIfAlreadyAggregate) {
            return innerError;
        }
        var separator = '\n------------------------------------------------\n';
        message += separator + "Inner Error:\n";
        if (typeof innerError === 'string') {
            message += "Message: " + innerError;
        }
        else {
            if (innerError.message) {
                message += "Message: " + innerError.message;
            }
            else {
                message += "Unknown Inner Error Type. Displaying Inner Error as JSON:\n " + JSON.stringify(innerError, null, '  ');
            }
            if (innerError.stack) {
                message += "\nInner Error Stack:\n" + innerError.stack;
                message += '\nEnd Inner Error Stack';
            }
        }
        message += separator;
    }
    var e = new Error(message);
    if (innerError) {
        e.innerError = innerError;
    }
    return e;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWdncmVnYXRlRXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJBZ2dyZWdhdGVFcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7R0FLRztBQUVILFNBQVMsZ0JBQWdCLENBQUMsS0FBVTtJQUNoQyxPQUFPLENBQUMsQ0FBQyxLQUFLLENBQUMsVUFBVSxDQUFDO0FBQzlCLENBQUM7QUFHRDs7Ozs7O0dBTUc7QUFDSCxNQUFNLFVBQVUsY0FBYyxDQUMxQixPQUFlLEVBQ2YsVUFBa0IsRUFDbEIsc0JBQWdDO0lBRWhDLDJDQUEyQztJQUMzQyxJQUFJLFVBQVUsRUFBRTtRQUNaLElBQUksZ0JBQWdCLENBQUMsVUFBVSxDQUFDLElBQUksc0JBQXNCLEVBQUU7WUFDeEQsT0FBTyxVQUFVLENBQUM7U0FDckI7UUFFRCxJQUFNLFNBQVMsR0FBRyxzREFBc0QsQ0FBQztRQUV6RSxPQUFPLElBQU8sU0FBUyxtQkFBZ0IsQ0FBQztRQUV4QyxJQUFJLE9BQU8sVUFBVSxLQUFLLFFBQVEsRUFBRTtZQUNoQyxPQUFPLElBQUksY0FBWSxVQUFZLENBQUM7U0FDdkM7YUFBTTtZQUNILElBQUksVUFBVSxDQUFDLE9BQU8sRUFBRTtnQkFDcEIsT0FBTyxJQUFJLGNBQVksVUFBVSxDQUFDLE9BQVMsQ0FBQzthQUMvQztpQkFBTTtnQkFDSCxPQUFPLElBQUksaUVBQStELElBQUksQ0FBQyxTQUFTLENBQ3BGLFVBQVUsRUFDVixJQUFJLEVBQ0osSUFBSSxDQUNMLENBQUM7YUFDUDtZQUVELElBQUksVUFBVSxDQUFDLEtBQUssRUFBRTtnQkFDbEIsT0FBTyxJQUFJLDJCQUF5QixVQUFVLENBQUMsS0FBTyxDQUFDO2dCQUN2RCxPQUFPLElBQUkseUJBQXlCLENBQUM7YUFDeEM7U0FDSjtRQUVELE9BQU8sSUFBSSxTQUFTLENBQUM7S0FDeEI7SUFFRCxJQUFNLENBQUMsR0FBRyxJQUFJLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQztJQUM3QixJQUFJLFVBQVUsRUFBRTtRQUNYLENBQVMsQ0FBQyxVQUFVLEdBQUcsVUFBVSxDQUFDO0tBQ3RDO0lBRUQsT0FBTyxDQUFDLENBQUM7QUFDYixDQUFDIn0=